var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.999 3.24902C9.40902 3.24902 3.24902 9.40902 3.24902 16.999C3.24902 24.589 9.40902 30.749 16.999 30.749C24.589 30.749 30.749 24.589 30.749 16.999C30.749 9.40902 24.589 3.24902 16.999 3.24902ZM18.374 23.874H15.624V21.124H18.374V23.874ZM18.374 18.374H15.624V10.124H18.374V18.374Z",
    fill: "#EA2424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileErrorIcon);
export default __webpack_public_path__ + "static/media/profile_error_icon.a5c188d4e18ddc65836cead99dd35dcd.svg";
export { ForwardRef as ReactComponent };